import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ATP_DIALOG_DATA, AtpDialogService } from '../../components/atp-dialog/atp-dialog.service';
import { AtpHistoryData, IAtpHistory, IAtpPagination, IAtpSelectItem, AtpHistoryDetailData } from '../../atp-core';
import { AtpDialogRef } from '../../components/atp-dialog/atp-dialog-container.component';
import { AtpBasePageComponent } from '../../atp-base-page-component';
import { AtpHttpService, IAtpUser } from '../../services/atp-http.service';
import { AtpHttpErrorsService, AtpHttpErrorHandler } from '../../services/atp-http-errors.service';
import { AtpHistoryItemDetailComponent } from '../atp-history-item-detail/atp-history-item-detail.component';

@Component({
  selector: 'atp-history',
  templateUrl: './atp-history.component.html',
  host: {
    class: 'atp-history'
  }
})
export class AtpHistoryComponent<TEntity extends IAtpHistory> extends AtpBasePageComponent implements OnInit {

  constructor(protected api: AtpHttpService<IAtpUser>, protected httpErrors: AtpHttpErrorsService, protected dialog: MatDialog, protected router: Router,
    @Inject(ATP_DIALOG_DATA) public data: AtpHistoryData, protected dialogRef: AtpDialogRef<AtpHistoryComponent<IAtpHistory>>, protected atpDialog: AtpDialogService) {
    super();

    if (data.isShared) {
      this.displayedColumns.push('type');
    }
  }

  tableData: IAtpPagination<IAtpHistory>;

  displayedColumns: string[] = ['action', 'id', 'entityId', 'date', 'userName', 'roleName'];

  isNotData = false;

  pageSizeOptions: number[] = [5, 15, 25, 50, 100];

  dataSource = new MatTableDataSource<IAtpHistory>();

  pageInfo: PageEvent;
  sortInfo: Sort;

  pagination(event: PageEvent): void {
    this.pageInfo = event;
    // this.replaceStateLocation();
    this.getData();
  }

  sort(event: Sort): void {
    this.sortInfo = event;
    // this.replaceStateLocation();
    // this.getData();
  }

  ngOnInit() {
    this.tableData = this.data.items;
    this.dataSource.data = this.tableData.items;
    this.isNotData = !this.dataSource.data.length;
  }

  close() {
    this.dialogRef.close();
  }

  getData(): void {
    this.isBlockedPage = true;
    this.api['history' + this.data.baseGroupName](this.data.type, this.data.entityId, this.pageInfo.pageIndex + 1, this.pageInfo.pageSize, this.sortInfo ? this.sortInfo.active : '', this.sortInfo ? this.sortInfo.direction : '').subscribe(
      (result: IAtpPagination<IAtpHistory>) => {
        let userIdsItems = {};
        for (const item of result.items) {
          if (item.action == "Remove" && !this.data.canOpenRemoveItem) {
            item.haveJson = false;
          }
          if (!item.userId) {
            continue;
          }
          if (!userIdsItems[item.userId]) {
            userIdsItems[item.userId] = [];
          }
          userIdsItems[item.userId].push(item);
        }
        this.getUserNamesByIds(userIdsItems, result);
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getData(); }, this, [new AtpHttpErrorHandler(400, err.error)], this.data.backUrl);
      }
    );
  }

  protected getUserNamesByIds(userIdsItems: any, data: IAtpPagination<IAtpHistory>): void {
    this.isBlockedPage = true;
    this.api.getUserNamesByIds(Object.getOwnPropertyNames(userIdsItems)).subscribe(
      (users: IAtpSelectItem[]) => {
        for (const key in userIdsItems) {
          const user = users.find(x => x.id == key);
          // TODO: сделать везде проверку с удаленными !!!!
          for (const item of userIdsItems[key]) {
            if (user) {
              item.userName = user.value;
              item.roleName = (<any>user).roleName;
            }
            else {
              item.userName = 'Удален';
              item.roleName = 'Удален';
            }
          }
        }

        this.tableData = data;
        this.dataSource.data = this.tableData.items;
        this.isNotData = !this.dataSource.data.length;

        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getUserNamesByIds(userIdsItems, data); }, this, [new AtpHttpErrorHandler(400, err.error)], this.data.backUrl);
      }
    );
  }

  protected openRemoveItem(modelId: string, userIdsItems: any, data: IAtpPagination<IAtpHistory>, urlPath: string): void {
    this.isBlockedPage = true;
    this.api.getUserNamesByIds(Object.getOwnPropertyNames(userIdsItems)).subscribe(
      (users: IAtpSelectItem[]) => {
        for (const key in userIdsItems) {
          const user = users.find(x => x.id == key);
          for (const item of userIdsItems[key]) {
            if (user) {
              item.userName = user.value;
              item.roleName = (<any>user).roleName;
            }
            else {
              item.userName = 'Удален';
              item.roleName = 'Удален';
            }
          }
        }

        const arrUrlPath = urlPath.split('/');

        this.atpDialog.open(AtpHistoryComponent, { data: new AtpHistoryData(arrUrlPath[1], arrUrlPath[2], modelId, data, this.data.backUrl, false, false) });

        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getUserNamesByIds(userIdsItems, data); }, this, [new AtpHttpErrorHandler(400, err.error)], this.data.backUrl);
      }
    );
  }

  getItemDetail(model: TEntity): void {
    this.isBlockedPage = true;
    this.api.getHistoryItemDetail(model.urlPath, model.id).subscribe(
      (result: IAtpHistory | IAtpPagination<IAtpHistory>) => {
        if (model.action == "Remove") {
          let userIdsItems = {};
          for (const item of (<IAtpPagination<IAtpHistory>>result).items) {
            if (item.action == "Remove") {
              item.haveJson = false;
            }
            if (!item.userId) {
              continue;
            }
            if (!userIdsItems[item.userId]) {
              userIdsItems[item.userId] = [];
            }
            userIdsItems[item.userId].push(item);
          }

          this.openRemoveItem(model.id, userIdsItems, <IAtpPagination<IAtpHistory>>result, model.urlPath);
        }
        else {
          this.atpDialog.open(AtpHistoryItemDetailComponent, { data: new AtpHistoryDetailData(<IAtpHistory>result, this.data.backUrl) });
        }
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getItemDetail(model); }, this, [new AtpHttpErrorHandler(400, err.error)], this.data.backUrl);
      }
    );
  }

  exportInCsv() {
    this.isBlockedPage = true;
    this.api['exportHistoryInCsv']().subscribe(
      (result: any) => {
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(401, () => { this.exportInCsv(); }, this);
      }
    );
  }

}
